export var MenuSettingFormModel = undefined; // eslint回避
